 
import { NgFor, NgForOf } from '@angular/common';
import { Component, OnInit,EventEmitter,Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { AuthService } from 'app/core/auth/auth.service';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { Subject, takeUntil } from 'rxjs';
declare var $: any;

@Component({
  standalone: true,
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  imports:[MatButtonModule, NgFor, RouterLink]
 
})
 
export class PartnersComponent implements OnInit {

  public partnerLogos: any;
  public isScreenSmall: boolean;

  private _unsubscribeAll: Subject<any> = new Subject<any>();


  @Output() focusInput = new EventEmitter<void>();
  private _sharedMethods: any;


  constructor(
    private _strapiService: StrapiService, 
    private _fuseMediaWatcherService: FuseMediaWatcherService, 
    private _authService: AuthService,
    public router: Router,
  )
  {

  }

  focusOnParentInput(): void 
  {
    this.focusInput.emit();
  }

  ngOnInit(): void
  {
    
    this._fuseMediaWatcherService.onMediaChange$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(({matchingAliases}) =>
    {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('sm');
        if(this.isScreenSmall) {
          this.getPartnerImages(1);
        } else {
          this.getPartnerImages(4);

        }
        //this.updateSwiper();
    });
    
  }

  /**
     * On destroy
     */
  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }

  public getPartnerImages(slidesToShow: number){
    this._strapiService.getPartnerLogos().subscribe({
      next: (res: any)=>{
        this.partnerLogos = res?.data?.logos;
            // ## bug where it fails on the 'slick' function without timeout ##
            setTimeout(() => {
              const partnersElement = $('#partners');
              if (partnersElement.length) {
                partnersElement.slick({
                  autoplay: true,
                  autoplaySpeed: 10,
                  infinite: true,
                  speed: 3500,
                  slidesToShow: slidesToShow,
                  slidesToScroll: 1,
                  centerMode: true,
                  arrows: true,
                  swipeToSlide: true,
                  draggable: true
                });
              } else {
                console.error("Element #partners not found.");
              }
            }, 200);
            
      }
    })
  }

  public checkCoverage() {    
    if (this._authService._authenticated) {
      this.focusOnParentInput()
    } else {
      this.router.navigateByUrl("/sign-in")
    }
  }
  
}
